export default __webpack_public_path__ + "static/media/checkcircle.a5b60959.svg";